import React from "react";
import { Validation } from "../../../_helpers/validation/Validation";
import { ContactUsService } from "../../../_services/CommnService/ContactUs/ContactUsService";
import toastr from "toastr";
import { Container, Row, Col } from "react-bootstrap";
//import './form.css'
import { withRouter } from "react-router";
import MultiLanguageTranslation from "../../../_components/Translate/MultiLangTranslate";
import { multiLingual } from "../../../_components/Multilingualplaceholder/Multilingualplaceholder";
import LoaderWithLogo from "../../../_components/Loader/LoaderWithLogo";
import { connect } from "react-redux";
import DropDown from "../../../_components/_common/DropDown/DropDown";
import ReCAPTCHA from "react-google-recaptcha";
import { captchaKey } from "../../../_constants/Config/AryaConstants";
import ValidationError from "../../../_Pages/_webapp/arya2.0/CommonComponents/ValidationError/ValidationError";
import isLogin from "../../../_helpers/Common/helper";
import { FetchOption } from "../../../_services/CommnService/OptionService/FetchOption";
import { optionActions } from "../../../_actions";

class ReachOutUs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: "",
      last_name: "",
      phone_number: "",
      email: "",
      message: "",
      error: {},
      submitted: false,
      location: "",
      landline_number: "",
      changePaceholder: "",
      isLoading: false,
      commodity: "",
      funded_location: "",
      captchaToken: "",
      lang: "en",
      refreshCaptchaKey: 0,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);

    this.FormCustomField = [
      {
        field_name: "first_name",
        label: "First Name",
        type: "string",
        isRequired: true,
      },
      {
        field_name: "last_name",
        label: "Last Name",
        type: "string",
        isRequired: true,
      },
      {
        field_name: "email",
        label: "Email",
        type: "email",
        isRequired: true,
      },
      {
        field_name: "phone_number",
        label: "Phone number",
        type: "number",
        min: 10,
        max: 13,
        isRequired: true,
      },
      {
        field_name: "message",
        type: "string",
        label: "Message",
        isRequired: true,
      },
      {
        field_name: "location",
        type: "string",
        label: "Location",
        isRequired: true,
      },
    ];
  }

  componentDidMount() {
    setInterval(() => {
      if (multiLingual()["First Name"] !== this.state.changePaceholder) {
        this.setState({
          changePaceholder: multiLingual()["First Name"],
        });
      }
    }, 2000);
    let lang = localStorage.getItem("lang");
    this.setState({
      lang: lang,
    });
  }

  onChange(e) {
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        var errobj = {};

        /**call validation file for validation */
        errobj = Validation(this.state, this.FormCustomField);
        this.setState({ error: errobj });
      }
    );
  }

  createFormData() {
    var objdata = {
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      phone_number: this.state.phone_number,
      email: this.state.email,
      message: this.state.message,
      location: this.state.location,
      landline_number: this.state.landline_number,
      type: this.props.type ? this.props.type : 2,
      commodity: this.state.commodity,
      funded_location: this.state.funded_location,
      captcha_token: this.state.captchaToken,
    };
    return objdata;
  }

  unsetFormData() {
    this.setState({
      first_name: "",
      last_name: "",
      phone_number: "",
      email: "",
      message: "",
      error: {},
      submitted: false,
      location: "",
      landline_number: "",
      commodity: "",
      funded_location: "",
    });
  }

  async onSubmit(e) {
    e.preventDefault();

    var errobj = {};
    /**call validation file for validation */
    errobj = Validation(this.state, this.FormCustomField);
    if (this.props.finance) {
      if (this.state.commodity === "") {
        errobj.commodity = "Commodity is Required";
      }
      if (this.state.funded_location === "") {
        errobj.funded_location = "Location is Required";
      }
    }
    if (!isLogin() && !this.state.captchaToken) {
      errobj.captchaToken =
        "Please check the box indicating 'I am not a robot' to submit your application";
    }

    this.setState({ error: errobj, submitted: true, isLoading: true });

    /**
     * final checking for any error exists or not
     */
    var flag = 0;
    Object.keys(errobj).forEach((index) => {
      if (errobj[index] !== "") {
        flag = 1;
      }
    });

    if (flag === 0) {
      var registerdata = this.createFormData();
      const result = await ContactUsService.contactUs(registerdata);

      if (result?.data?.status_code === 200) {
        this.props.history.push("/lead-thank-you");
        toastr.info("Thank You");
        this.unsetFormData();
      } else {
        this.setState({ isLoading: false });
      }
    } else {
      this.setState({ isLoading: false });
    }
  }

  onchangeComodity = (e) => {
    this.setState({
      commodity: e.value,
    });
  };
  handleRefresh = () => {
    this.setState({
      refreshCaptchaKey: this.state.refreshCaptchaKey + 1
    });
  };
  captchChange = (value) => {
    this.setState({ error: { ...this.state.error, ["captchaToken"]: "" } });
    this.setState({ captchaToken: value });
    // setData((prev) => ({ ...prev, ["captchaToken"]: value }));
  };

  onExpired = (value) => {
    this.setState({ captchaToken: "" });
    this.setState({ error: { ...this.state.error, ["captchaToken"]: "" } });

    // setData((prev) => ({ ...prev, ["captchaToken"]: "" }));
  };
  componentDidMount = async () => {
    if (!this.props.option_master) {
      let responseOptions = await FetchOption.getByMetaType();
      if (responseOptions?.data?.status_code === 200) {
        this.props.add(responseOptions.data.data);
        this.props.addOption(responseOptions.data.data);
      }
    }
  }
  render() {
    const commodity = this.props.option.options_master.commodity;
    return (
      <section className="leaveusMsg-bx">
        <LoaderWithLogo isLoading={this.state.isLoading}></LoaderWithLogo>
        <Container>
          <div
            className="need-finance-form-loan"
            style={{
              display: "flex",
              alignItems: "flex-end",
              marginBottom: "20px",
              padding: "0 30px",
            }}
          >
            {this.props.finance ? (
              <h2>
                <MultiLanguageTranslation
                  title={"NEED_FINANCE_ON_COMMODITIES"}
                />
                <span>
                  <MultiLanguageTranslation
                    title={
                      "Leave us a message & our Finance Expert will get back to you soon"
                    }
                  />
                </span>
              </h2>
            ) : (
              <h2>
                <MultiLanguageTranslation
                  title={"Did not find what you are looking for?"}
                ></MultiLanguageTranslation>{" "}
                <span>
                  <MultiLanguageTranslation
                    title={"Leave_us_message_and_we_will_get_back"}
                  ></MultiLanguageTranslation>{" "}
                </span>
              </h2>
            )}
          </div>

          <form onSubmit={this.onSubmit.bind(this)}>
            <Row>
              <Col md={6}>
                <div className="form-group">
                  <label>
                    <MultiLanguageTranslation title="First Name" />
                  </label>
                  <input
                    className="first-name-for-tag"
                    name="first_name"
                    type="text"
                    id=""
                    placeholder={multiLingual()["First Name"]}
                    onChange={this.onChange.bind(this)}
                    value={this.state.first_name}
                  />
                  {this.state.submitted &&
                    this.state.error.first_name !== "" && (
                      <div className="fromerror">
                        {this.state.error.first_name}
                      </div>
                    )}
                </div>
              </Col>
              <Col md={6}>
                <div className="form-group">
                  <label>
                    <MultiLanguageTranslation title="Last Name" />
                  </label>
                  <input
                    name="last_name"
                    type="text"
                    id=""
                    placeholder={multiLingual()["Last Name"]}
                    onChange={this.onChange.bind(this)}
                    value={this.state.last_name}
                  />
                  {this.state.submitted &&
                    this.state.error.last_name !== "" && (
                      <div className="fromerror">
                        {this.state.error.last_name}
                      </div>
                    )}
                </div>
              </Col>
              <Col md={6}>
                <div className="form-group">
                  <label>
                    <MultiLanguageTranslation title="Phone Number" />
                  </label>
                  <input
                    name="phone_number"
                    type="tel"
                    id=""
                    placeholder={multiLingual()["Phone Number"]}
                    onChange={this.onChange.bind(this)}
                    value={this.state.phone_number}
                  />
                  {this.state.submitted &&
                    this.state.error.phone_number !== "" && (
                      <div className="fromerror">
                        {this.state.error.phone_number}
                      </div>
                    )}
                </div>
              </Col>

              <Col md={6}>
                <div className="form-group">
                  <label>
                    <MultiLanguageTranslation title="Landline Number" />
                  </label>
                  <input
                    type="number"
                    name="landline_number"
                    value={this.state.landline_number}
                    placeholder={multiLingual()["Landline Number"]}
                    onChange={this.onChange.bind(this)}
                  />
                </div>
              </Col>

              <Col md={6}>
                <div className="form-group">
                  <label>
                    <MultiLanguageTranslation title="Email Address" />
                  </label>
                  <input
                    name="email"
                    type="email"
                    id=""
                    placeholder={multiLingual()["E-mail Address"]}
                    onChange={this.onChange.bind(this)}
                    value={this.state.email}
                  />
                  {this.state.submitted && this.state.error.email !== "" && (
                    <div className="fromerror">{this.state.error.email}</div>
                  )}
                </div>
              </Col>

              <Col md={6}>
                <div className="form-group">
                  <label>
                    <MultiLanguageTranslation title="Location" />
                  </label>
                  <input
                    name="location"
                    type="text"
                    id=""
                    placeholder={multiLingual()["Location"]}
                    onChange={this.onChange.bind(this)}
                    value={this.state.location}
                  />
                  {this.state.submitted && this.state.error.location !== "" && (
                    <div className="fromerror">{this.state.error.location}</div>
                  )}
                </div>
              </Col>

              {this.props.finance && (
                <>
                  <Col md={6}>
                    <div className="form-group">
                      <label>
                        <MultiLanguageTranslation title="Funding Location" />
                      </label>
                      <input
                        name="funded_location"
                        type="text"
                        id=""
                        placeholder={multiLingual()["Funding Location"]}
                        onChange={this.onChange.bind(this)}
                        value={this.state.funded_location}
                      />
                      {this.state.submitted &&
                        this.state.error.funded_location !== "" && (
                          <div className="fromerror">
                            {this.state.error.funded_location}
                          </div>
                        )}
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="form-group">
                      <label>
                        <MultiLanguageTranslation title="Commodity" />
                      </label>
                      {commodity && (
                        <DropDown
                          className="customSelect"
                          preselected={this.state.commodity}
                          options={commodity.map((obj) => {
                            return {
                              label:
                                this.state.lang === "hindi"
                                  ? obj.label_hi
                                  : obj.label,
                              value: obj.value,
                            };
                          })}
                          onChange={this.onchangeComodity}
                        // isDisabled={this.state.isWareHouse}
                        />
                      )}

                      {this.state.submitted &&
                        this.state.error.commodity !== "" && (
                          <div className="fromerror">
                            {this.state.error.commodity}
                          </div>
                        )}
                    </div>
                  </Col>
                </>
              )}

              <Col md={12}>
                <div className="form-group">
                  <label>
                    <MultiLanguageTranslation title="What is your Requirement" />
                  </label>
                  <textarea
                    name="message"
                    id=""
                    rows="4"
                    cols="6"
                    placeholder={multiLingual()["What is your Requirement ?"]}
                    onChange={this.onChange.bind(this)}
                    value={this.state.message}
                  ></textarea>
                  {this.state.submitted && this.state.error.message !== "" && (
                    <div className={`fromerror`} style={{ bottom: "0" }}>{this.state.error.message}</div>
                  )}
                </div>
              </Col>
              {!isLogin() && <div className={`margin-bottom16 padding-left16`}>
                <ReCAPTCHA
                  sitekey={captchaKey}
                  key={this.state.refreshCaptchaKey}
                  onChange={this.captchChange}
                  onExpired={this.onExpired}
                />
                {this.state.error.captchaToken && (
                  <div className="margin-bottom16">
                    <ValidationError
                      showIcon={false}
                      text={this.state.error.captchaToken}
                      // imageClassName={isMobile ? "" : style["width-18"]}
                      textClassName={"fromerror mt-2 padding-right12"}
                    />
                  </div>
                )}
              </div>}
              <Col md={12} className="text-center">
                <button type="submit" className="primaryP">
                  <MultiLanguageTranslation
                    title={"Submit"}
                  ></MultiLanguageTranslation>
                </button>
              </Col>
            </Row>
          </form>
        </Container>
      </section >
    );
  }
}

//export default withRouter(ReachOutUs);

const mapDispatchToProps = {
  // userFilledDataChache: UserDataActions.userFilledDataChache,
  add: optionActions.add,
  addOption: optionActions.addOption,
};

function mapStateToProps(state) {
  const { userDataCache } = state.userData;
  const { option } = state;
  return {
    userDataCache,
    option,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ReachOutUs));
